export default __webpack_public_path__ + "static/media/low_spenders.a1872631.svg";